import React, { useState, useEffect } from "react";
import {
  Card,
  Col,
  Row,
  Input,
  InputNumber,
  Select,
  Button,
  Typography,
  Space,
  Divider,
  Form,
  message,
  Spin,
  Modal,
} from "antd";
import {
  CalculatorOutlined,
  CheckCircleOutlined,
  SaveOutlined,
  UserOutlined,
  WalletOutlined,
  FileTextOutlined,
  FilePdfOutlined,
  EyeOutlined,
  PrinterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import axios from "axios";
import MotionHoc from "../../../utils/MotionHoc";
import { PaymentLawyerPdfJs } from "../contractDetail/export/PaymentLawyerPdfJs";
import { PaymentArLawyerPdfjs } from "../contractDetail/export/PaymentArLawyerPdfjs";
import { getFileType } from "../contractDetail/contractDetailNew/utils";
import PdfPreviewModal from "../contractDetail/contractDetailNew/components/PdfPreviewModal";
import {
  BASE_URL_BEN,
  GET_LOAD_IMAGE_NEW_ALL,
  GET_LOAD_IMAGE_NEW_BY,
  HEADERS_UPIMAGE,
} from "../../API/apiUrls";
import dayjs from "dayjs";

const { Title, Text } = Typography;
const { confirm } = Modal;

const InfoRow = ({ label, value, color, strong, fontSize }) => (
  <Row justify="space-between" style={{ marginBottom: 8 }}>
    <Col>
      <Typography.Text type="secondary">{label}</Typography.Text>
    </Col>
    <Col>
      <Typography.Text
        strong={strong}
        style={{ color: color || "inherit", fontSize: fontSize }}
      >
        {value}
      </Typography.Text>
    </Col>
  </Row>
);

const formatThaiDate = (v) =>
  v ? dayjs(v).add(543, "year").format("D MMM YY") : "-";

const Main = () => {
  const [form] = Form.useForm();
  const tk = localStorage.getItem("TOKEN");
  // const API_LINE_NOTI =
  //   "https://noti-lawyer-539174983798.asia-southeast1.run.app/api/notify/lawsuit/docs-complete";
  const API_LINE_NOTI =
    "  https://noti-lawyer-1024031113167.asia-southeast3.run.app/api/notify/lawsuit/docs-complete";

  const header = {
    "Content-Type": "application/json",
    "X-API-Key": "your-secret-key-here",
  };

  const [dataList, setDataList] = useState([]); // เก็บ Array ทั้งหมดที่ได้จาก API
  const [getPAYCODE, setGetPAYCODE] = useState([]);
  const [customerData, setCustomerData] = useState(null); // เก็บข้อมูลคนเดียวที่ถูกเลือก
  const [dataAll, setDataAll] = useState(null);
  const [dataCal, setDataCal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [money, setMoney] = useState(0);
  const [sale, setSale] = useState(0);
  const [paymentMode, setPaymentMode] = useState(null);
  const [paymentType, setPaymentType] = useState("01");
  const [otherPayments, setOtherPayments] = useState({});
  const [bill, setBill] = useState(null);
  const [flagPay, setFlagPay] = useState(true);
  const [dataRec, setDataRec] = useState(null);
  const [lockInput, setLockInput] = useState(false);
  const [rejudgeImages, setRejudgeImages] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");

  useEffect(() => {
    // 1. สร้างตัวแปรมาเช็คว่า Component ยัง mount อยู่ไหม
    let isMounted = true;

    const loadData = async () => {
      setLoading(true);

      try {
        const response = await axios.get(
          "https://api-payment-1024031113167.asia-southeast1.run.app/api-payment/get-paytype",
        );

        // 2. เช็คสถานะก่อนอัปเดต State
        if (isMounted) {
          if (response?.data && Array.isArray(response.data)) {
            setGetPAYCODE(response.data);
          } else {
            message.error({
              content: (
                <span style={{ fontSize: "18px" }}>
                  รูปแบบข้อมูลไม่ถูกต้อง หรือไม่พบข้อมูล
                </span>
              ),
              style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
              duration: 3, // แสดงนาน 3 วินาที
            });
          }
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error in loadData: ", error);
          const errMsg =
            error.response?.data?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
          message.error(errMsg);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadData();

    // 3. Cleanup function: จะรันเมื่อ Component ถูกทำลาย
    return () => {
      isMounted = false;
    };
  }, []);

  const currencyFormatOne = (amount) => {
    if (amount) {
      return Number(amount)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    } else {
      return "0.00";
    }
  };

  // 1. ฟังก์ชันค้นหาข้อมูล (Back-end)
  const onSearch = async (value) => {
    if (!value) return message.warning("กรุณากรอกเลขที่สัญญาเพื่อค้นหา");
    const payload = value.trim();
    setLoading(true);
    setCustomerData(null);
    setDataAll(null);
    setDataCal(null);
    setMoney(0);
    setSale(0);
    setBill(null);
    setFlagPay(true);
    setDataRec(null);
    setPaymentMode(null);
    setOtherPayments({});
    setLockInput(false);
    try {
      // ปรับ URL ให้ตรงกับ Back-end ของคุณ (เช่น Go Gin API ที่คุณใช้อยู่)
      const response = await axios.post(
        `${BASE_URL_BEN}/auth/main-payment-contno`,
        { CONTNO: payload },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tk}`,
          },
        },
      );
      console.log(response.data);
      const data = response.data?.data; // สมมติว่าคืนค่าเป็น Array ที่คุณให้มา

      if (data && data.length > 0) {
        setDataAll(response.data); // รวมทุกอย่างในนี้
        setDataList(data); // judgeDef
        loadPath(data[0]?.loanId);
        if (response.data?.flagLoanNew === 1) {
          if (Number(response.data?.loanNew?.LOAN_NEW_AR) !== 0) {
            console.log("1 มี ลูกหนี้ เหลือ อยู่");
            setPaymentMode(3);
          } else {
            console.log("1 ไม่มี ลูกหนี้ เหลือ อยู่");
            setPaymentMode(1);
          }
        } else if (response.data?.loanJudge) {
          // ตารางดิว: ไม่มีการรับค่าใช้จ่ายอื่นๆ → ใช้รับปกติ (โหมด 1) เสมอ
          console.log("ตารางดิว: รับปกติ");
          setPaymentMode(1);
        } else {
          // flagLoanNew === 2 (พิพากษาปกติเดิม): ใช้ arKong ตัดสิน paymentMode
          if (Number(data[0]?.arKong) !== 0) {
            console.log("2 มี ลูกหนี้ เหลือ อยู่");
            setPaymentMode(3);
          } else {
            console.log("2 ไม่มี ลูกหนี้ เหลือ อยู่");
            setPaymentMode(1);
          }
        }
        setCustomerData(data[0]); // เลือกคนแรกให้โดยอัตโนมัติ
        message.success({
          content: (
            <span style={{ fontSize: "18px" }}>
              พบข้อมูล {data.length} รายการ
            </span>
          ),
          style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
          duration: 3, // แสดงนาน 3 วินาที
        });
      } else {
        message.error({
          content: (
            <span style={{ fontSize: "18px" }}>
              ไม่พบข้อมูล อาจจะปิดไปแล้ว หรือเลขสัญญาไม่ถูกต้อง
            </span>
          ),
          style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
          duration: 3, // แสดงนาน 3 วินาที
        });
      }
    } catch (error) {
      console.error("Search Error:", error);
      // จัดการ error message จาก server
      const errMsg =
        error.response?.data?.message ||
        "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
      message.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  // 2. ฟังก์ชันเลือกประเภทการชำระ และล้างค่า flagLoanNew 1 ทำยอม 2 ปกติ
  const handleModeChange = (mode) => {
    if (mode === 1) {
      if (dataAll?.flagLoanNew === 1) {
        if (Number(dataAll?.loanNew?.LOAN_NEW_AR) !== 0) {
          return message.error({
            content: (
              <span style={{ fontSize: "18px" }}>
                ต้องรับลูกหนี้อื่นๆ ให้หมดก่อน
              </span>
            ),
            style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
            duration: 3, // แสดงนาน 3 วินาที
          });
        }
      } else if (dataAll?.flagLoanNew === 2) {
        if (Number(customerData?.arKong) !== 0) {
          return message.error({
            content: (
              <span style={{ fontSize: "18px" }}>
                ต้องรับลูกหนี้อื่นๆ ให้หมดก่อน
              </span>
            ),
            style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
            duration: 3, // แสดงนาน 3 วินาที
          });
        }
      } else {
        return message.warning("ไม่ตรงเงื่อนไข ฟังก์ชันเลือกประเภทการชำระ");
      }
    } else if (mode === 3) {
    } else {
      return message.warning("ไม่ตรงเงื่อนไข ฟังก์ชันเลือกประเภทการชำระ");
    }

    setPaymentMode(mode);
    setMoney(0);
    setSale(0);
    setDataCal(null); // ล้างผลการคำนวณเก่าทิ้ง
    setOtherPayments({});
    // ล้างค่าในช่อง InputNumber
    form.setFieldsValue({
      money: 0,
      sale: 0,
    });
    message.info(`เปลี่ยนประเภทเป็น: ${getModeName(mode)}`);
  };

  const getModeName = (mode) => {
    // if (mode === 1) return "รับค่าแทน";
    // if (mode === 2) return "รับค่าขาดประโยชน์";
    if (mode === 1) return "รับปกติ";
    if (mode === 3) return "รับค่าใช้จ่ายอื่นๆ";
    return "";
  };

  // ฟังก์ชันเมื่อเปลี่ยนคนใน Select
  const handleSelectCustomer = (val) => {
    // 1. หาข้อมูลลูกค้าใหม่ที่ถูกเลือก
    const selected = dataList.find((item) => item.idJudgeDef === val);
    // console.log(selected)
    if (dataAll?.flagLoanNew === 1) {
      if (Number(dataAll?.loanNew?.LOAN_NEW_AR) !== 0) {
        console.log("1 มี ลูกหนี้ เหลือ อยู่");
        setPaymentMode(3);
      } else {
        console.log("1 ไม่มี ลูกหนี้ เหลือ อยู่");
        setPaymentMode(1);
      }
    } else if (dataAll?.loanJudge) {
      // ตารางดิว: ไม่มีการรับค่าใช้จ่ายอื่นๆ → ใช้รับปกติ (โหมด 1) เสมอ
      console.log("ตารางดิว: รับปกติ");
      setPaymentMode(1);
    } else {
      if (Number(selected?.arKong) !== 0) {
        console.log("2 มี ลูกหนี้ เหลือ อยู่");
        setPaymentMode(3);
      } else {
        console.log("2 ไม่มี ลูกหนี้ เหลือ อยู่");
        setPaymentMode(1);
      }
    }

    setCustomerData(selected);

    // 2. ล้างค่าต่างๆ เพื่อเริ่มคำนวณใหม่
    setMoney(0); // ล้างยอดเงินรับจริง
    setSale(0); // ล้างส่วนลด
    setDataCal(null); // ล้างผลการคำนวณเก่าทิ้ง
    setOtherPayments({}); // ล้างยอดลูกหนี้อื่นๆ (ถ้ามี)

    // 3. (สำคัญ) ล้างค่าใน Form ของ Ant Design ด้วย เพื่อให้หน้าจออัปเดตเลข 0 ทันที
    form.setFieldsValue({
      money: 0,
      sale: 0,
    });

    console.log("เปลี่ยนผู้ชำระเป็น:", selected?.NAME1);
  };

  const handleMoney = (value) => {
    setDataCal(null);
    if (value) {
      setMoney(value);
    } else {
      setMoney(0);
    }
  };

  const handleSale = (value) => {
    setDataCal(null);
    if (value) {
      if (dataAll?.flagLoanNew === 1) {
        const beeypupValue = Number(dataAll?.loanNew?.RES_BEEYPUP) || 0;
        if (value > beeypupValue) {
          // setSale(0);
          // form.setFieldsValue({ sale: 0 });
          // return message.warning(
          //   "เกิดข้อผิดพลาด ไม่สามารถกรอกส่วนลดได้เกินยอดดอกเบี้ยคงค้าง",
          // );
          setSale(value);
          return message.warning("กรอกส่วนลดเกินยอดดอกเบี้ยคงค้าง");
        }
      }
      setSale(value);
    } else {
      setSale(0);
    }
  };

  // 3. ฟังก์ชันคำนวณยอด
  const handleCalculate = async () => {
    if (!money) return message.warning("กรุณากรอกยอดเงินก่อน");
    setDataCal(null); // ล้างข้อมูลเก่าก่อนค้นหาใหม่
    if (dataAll?.flagLoanNew === 1) {
      const ccb_loan_new =
        (Number(dataAll?.loanNew?.LOAN_NEW_TONBALANCE) || 0) +
        (Number(dataAll?.loanNew?.RES_BEEYPUP) || 0);
      console.log("ccb_loan_new : ", ccb_loan_new);
      if (!dataAll?.loanNew)
        return message.warning("เกิดข้อผิดพลาด loanNew กรุณาติดต่อไอที");
      // 1. นำค่ามาแปลงเป็นตัวเลข + ปัด 2 ตำแหน่งทศนิยม กัน floating-point เพี้ยน (เช่น 226543.83000000002)
      const totalAmount =
        Math.round(((Number(money) || 0) + (Number(sale) || 0)) * 100) / 100;
      if (totalAmount - ccb_loan_new > 0.005) {
        return message.error({
          content: <span style={{ fontSize: "18px" }}>ยอดเกินที่กำหนด</span>,
          style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
          duration: 3, // แสดงนาน 3 วินาที
        });
      }
      console.log("dataAll", dataAll);

      const payload = {
        PAYCODE: paymentType,
        idJudge: customerData?.idJudge,
        idJudgeDef: customerData?.idJudgeDef,
        newContno: customerData?.newContno,
        ref: customerData?.ref,
        money: money,
        sale: sale,
        flagLoanNew: 1,
      };
      console.log("payload--->", payload);

      setLoading(true);
      try {
        // ปรับ URL ให้ตรงกับ Back-end ของคุณ (เช่น Go Gin API ที่คุณใช้อยู่)
        const response = await axios.post(
          `${BASE_URL_BEN}/auth/calculate-new-contno`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tk}`,
            },
          },
        );
        console.log("calculate ทำยอม : ", response.data);
        if (response.status === 200) {
          setDataCal({
            flagLoanNew: dataAll?.flagLoanNew,
            PAYCODE: paymentType,
            money: money,
            sale: sale,
            loanNewId: dataAll?.loanNew?.loanNewId,
            NEWCONTNO: dataAll?.loanNew?.NEWCONTNO,
            NCSHPRC: dataAll?.loanNew?.NCSHPRC,
            LOAN_NEW_TONBALANCE: dataAll?.loanNew?.LOAN_NEW_TONBALANCE,
            LOAN_NEW_SMPAY: dataAll?.loanNew?.LOAN_NEW_SMPAY,
            MAX_DATE_LOAN_NEW: dataAll?.loanNew?.MAX_DATE_LOAN_NEW,
            idJudge: customerData?.idJudge,
            idJudgeDef: customerData?.idJudgeDef,
            ref: customerData?.ref,
            RES_BEEYPUP: response.data?.RES_BEEYPUP,
            /* โชว์หน้าบ้าน */
            PAYAMT: response.data?.PAYAMT, // ใช้ตัวแปรที่รวมแล้วได้เลย
            PAYAMT_V: response.data?.PAYAMT_V,
            PAYAMT_N: response.data?.PAYAMT_N,
            flagCloses: response.data?.flagCloses,
          });
          message.success({
            content: (
              <span style={{ fontSize: "18px" }}>คำนวณยอดเรียบร้อย</span>
            ),
            style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
            duration: 3, // แสดงนาน 3 วินาที
          });
        } else if (response.status === 201) {
          message.error({
            content: (
              <div style={{ textAlign: "left", lineHeight: "1.6" }}>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#ff4d4f",
                  }}
                >
                  เกิดข้อผิดพลาด !!!
                </div>
                <div style={{ fontSize: "18px" }}>ยอดรับเกินที่กำหนด</div>
              </div>
            ),
            style: {
              marginTop: "10vh",
            },
            duration: 5, // เพิ่มเวลาหน่อยเพราะข้อความยาวขึ้น
          });
        } else {
          message.error({
            content: <span style={{ fontSize: "18px" }}>ไม่พบข้อมูล</span>,
            style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
            duration: 3, // แสดงนาน 3 วินาที
          });
        }
      } catch (error) {
        console.error("Search Error:", error);
        // จัดการ error message จาก server
        const errMsg =
          error.response?.data?.message ||
          "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
        message.error(errMsg);
      } finally {
        setLoading(false);
      }
    } else if (dataAll?.loanJudge) {
      // คำนวณ พิพากษาปกติ แบบตารางดิว (คำนวณหน้าบ้าน) — ตัดเข้าตามงวดใน dues
      const lj = dataAll?.loanJudge;
      const closing = Number(lj?.closingbalance) || 0;
      // ปัดเป็น 2 ตำแหน่งทศนิยม กัน floating-point เพี้ยน (เช่น 226543.83000000002)
      const totalAmount =
        Math.round(((Number(money) || 0) + (Number(sale) || 0)) * 100) / 100;
      // console.log(totalAmount, closing)
      if (totalAmount - closing > 0.005) {
        return message.error({
          content: <span style={{ fontSize: "18px" }}>ยอดเกินที่กำหนด</span>,
          style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
          duration: 3, // แสดงนาน 3 วินาที
        });
      }
      const payload = {
        PAYCODE: paymentType,
        idJudge: customerData?.idJudge,
        idJudgeDef: customerData?.idJudgeDef,
        newContno: customerData?.newContno,
        ref: customerData?.ref,
        loan_judge_id: dataAll?.loanJudge?.loanJudgeId,
        money: money,
        sale: sale,
      };

      setLoading(true);

      try {
        // ปรับ URL ให้ตรงกับ Back-end ของคุณ (เช่น Go Gin API ที่คุณใช้อยู่)
        const response = await axios.post(
          `${BASE_URL_BEN}/auth/calculate-new-contno`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tk}`,
            },
          },
        );
        console.log("calculate พิพากษาปกติ แบบตารางดิว : ", response.data);

        if (response.status === 200) {
          setDataCal(response.data);
          message.success({
            content: (
              <span style={{ fontSize: "18px" }}>คำนวณยอดเรียบร้อย</span>
            ),
            style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
            duration: 3, // แสดงนาน 3 วินาที
          });
        } else if (response.status === 201) {
          message.error({
            content: (
              <div style={{ textAlign: "left", lineHeight: "1.6" }}>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#ff4d4f",
                  }}
                >
                  เกิดข้อผิดพลาด !!!
                </div>
                <div style={{ fontSize: "18px" }}>
                  ยอด{" "}
                  {response?.data?.error === "ยอดเกิน Cost"
                    ? "ค่าขาดประโยชน์"
                    : "ค่าแทน/ต้นเงิน"}{" "}
                  รับเกินที่กำหนด
                </div>
                <div style={{ fontSize: "18px", color: "#666" }}>
                  จำนวนเงินที่รับได้{" "}
                  {response?.data?.error === "ยอดเกิน Cost"
                    ? Number(customerData?.CCBCost).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    : Number(customerData?.CCB).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                </div>
              </div>
            ),
            style: {
              marginTop: "10vh",
            },
            duration: 5, // เพิ่มเวลาหน่อยเพราะข้อความยาวขึ้น
          });
        } else {
          message.error({
            content: <span style={{ fontSize: "18px" }}>ไม่พบข้อมูล</span>,
            style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
            duration: 3, // แสดงนาน 3 วินาที
          });
        }
      } catch (error) {
        console.error("Search Error:", error);
        // จัดการ error message จาก server
        const errMsg =
          error.response?.data?.message ||
          "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
        message.error(errMsg);
      } finally {
        setLoading(false);
      }
    } else if (dataAll?.flagLoanNew === 2) {
      console.log("คำนวณ พิพากษาปกติ");
      const payload = {
        PAYCODE: paymentType,
        idJudge: customerData?.idJudge,
        idJudgeDef: customerData?.idJudgeDef,
        newContno: customerData?.newContno,
        ref: customerData?.ref,
        typePay:
          customerData?.costOfUselessness > 0 && customerData?.LACK_BALANCE > 0
            ? 2
            : 1,
        money: money,
        sale: sale,
      };

      setLoading(true);

      try {
        // ปรับ URL ให้ตรงกับ Back-end ของคุณ (เช่น Go Gin API ที่คุณใช้อยู่)
        const response = await axios.post(
          `${BASE_URL_BEN}/auth/calculate-new-contno`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tk}`,
            },
          },
        );
        console.log("calculate พิพากษาปกติ : ", response.data);

        if (response.status === 200) {
          setDataCal(response.data);
          message.success({
            content: (
              <span style={{ fontSize: "18px" }}>คำนวณยอดเรียบร้อย</span>
            ),
            style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
            duration: 3, // แสดงนาน 3 วินาที
          });
        } else if (response.status === 201) {
          message.error({
            content: (
              <div style={{ textAlign: "left", lineHeight: "1.6" }}>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#ff4d4f",
                  }}
                >
                  เกิดข้อผิดพลาด !!!
                </div>
                <div style={{ fontSize: "18px" }}>
                  ยอด{" "}
                  {response?.data?.error === "ยอดเกิน Cost"
                    ? "ค่าขาดประโยชน์"
                    : "ค่าแทน/ต้นเงิน"}{" "}
                  รับเกินที่กำหนด
                </div>
                <div style={{ fontSize: "18px", color: "#666" }}>
                  จำนวนเงินที่รับได้{" "}
                  {response?.data?.error === "ยอดเกิน Cost"
                    ? Number(customerData?.CCBCost).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    : Number(customerData?.CCB).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                </div>
              </div>
            ),
            style: {
              marginTop: "10vh",
            },
            duration: 5, // เพิ่มเวลาหน่อยเพราะข้อความยาวขึ้น
          });
        } else {
          message.error({
            content: <span style={{ fontSize: "18px" }}>ไม่พบข้อมูล</span>,
            style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
            duration: 3, // แสดงนาน 3 วินาที
          });
        }
      } catch (error) {
        console.error("Search Error:", error);
        // จัดการ error message จาก server
        const errMsg =
          error.response?.data?.message ||
          "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
        message.error(errMsg);
      } finally {
        setLoading(false);
      }
    } else {
      message.error({
        content: (
          <span style={{ fontSize: "18px" }}>
            ไม่ตรงกับเงื่อนไข กรุณาติดต่อไอที
          </span>
        ),
        style: { marginTop: "10vh", fontSize: "20px", padding: "5px" },
        duration: 3, // แสดงนาน 3 วินาที
      });
    }
  };

  // เช็คเงื่อนไขปุ่มคำนวณ (ต้องเลือก 1 หรือ 2 ก่อน)
  const canCalculate = paymentMode === 1 || paymentMode === 2;

  const showConfirm = () => {
    if (!flagPay)
      return message.warning("error ข้อมูลมีการอัปเดตกรุณากดค้นหาสัญญาใหม่");
    if (!dataCal) return message.warning("กรุณากดคำนวณก่อน");
    confirm({
      title: "ยืนยันการบันทึกรายการรับเงิน?",
      icon: <SaveOutlined style={{ color: "#1d39c4" }} />,
      content: (
        <div>
          <div>
            เลขที่สัญญา:{" "}
            <span style={{ fontWeight: "bold" }}>
              {customerData?.newContno}
            </span>
          </div>
          <div>
            ยอดรับ:{" "}
            <span style={{ color: "#1d39c4" }}>
              ฿{currencyFormatOne(money)}
            </span>
          </div>
          <div>
            ส่วนลด:{" "}
            <span style={{ color: "#cf1322" }}>฿{currencyFormatOne(sale)}</span>
          </div>
        </div>
      ),
      okText: "ยืนยันบันทึก",
      cancelText: "ยกเลิก",
      okButtonProps: { style: { background: "#1d39c4" } },
      onOk() {
        // เรียกฟังก์ชันยิงหลังบ้าน
        saveToBackend();
      },
      onCancel() {
        console.log("User cancelled");
      },
    });
  };

  // 3. ฟังก์ชันบันทึกข้อมูล (Save to DB)
  const saveToBackend = async () => {
    setLoading(true);
    const payload = {
      ...dataCal,
      PAYCODE: paymentType,
      money: money,
      sale: sale,
      PAYFOR:
        parseInt(customerData?.CCBCost) > 0
          ? "999"
          : dataAll.flagLoanNew === 1 &&
              dataAll.flagDue === 0 &&
              !dataAll.rejudgeRequest
            ? "777"
            : dataAll.flagLoanNew === 2 &&
                dataAll.flagDue === 1 &&
                !dataAll.rejudgeRequest
              ? "778"
              : dataAll.flagLoanNew === 2 &&
                  dataAll.flagDue === 1 &&
                  dataAll.rejudgeRequest
                ? "775"
                : dataAll.flagLoanNew === 1 &&
                    dataAll.flagDue === 0 &&
                    dataAll.rejudgeRequest
                  ? "776"
                  : "888",
    };

    try {
      message.loading({ content: "กำลังบันทึกข้อมูล...", key: "save_process" });

      const response = await axios.post(
        `${BASE_URL_BEN}/auth/insert-payment`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tk}`,
          },
        },
      );
      if (response.status === 200) {
        if (dataAll?.rejudgeRequest?.idRequest) {
          sendNoti();
        } else {
          console.log("ไม่เป็นเคสรีไฟแนนซ์");
        }
        message.success({
          content: (
            <span style={{ fontSize: "22px", fontWeight: "bold" }}>
              บันทึกรายการสำเร็จ!
            </span>
          ),
          key: "save_process",
          style: { padding: "12px 25px", fontSize: "22px", marginTop: "10vh" },
          duration: 3, // แสดงค้างไว้นาน 3 วินาที
        });
        console.log("response.data.bil", response.data.bil);
        console.log("payload", payload);

        // เพิ่ม Logic หลังบันทึกสำเร็จ เช่น ล้างค่า หรือเปิดใบเสร็จ
        if (response.data.bill) {
          setBill(response.data.bill);
          setLockInput(true);
        }
      }
    } catch (error) {
      console.log("error ", error);
      message.error({
        content: "เกิดข้อผิดพลาดในการบันทึก",
        key: "save_process",
      });
    } finally {
      setLoading(false);
    }
  };

  // ฟังก์ชันสำหรับอัปเดตยอดเงินรายตัว
  const handleOtherPaymentChange = (id, value) => {
    console.log(id, value);
    setOtherPayments((prev) => ({
      ...prev,
      [id]: value || 0,
    }));
  };

  const showConfirmAR = () => {
    // เช็คว่าถ้าเป็น null, undefined, 0, "" หรือไม่มีค่า
    if (!flagPay) {
      return message.warning("error ข้อมูลมีการอัปเดตกรุณากดค้นหาสัญญาใหม่");
    }
    if (!customerData?.idJudge || !customerData?.idJudgeDef) {
      return message.warning("error ค่าหลัก (ID) หายหรือเป็นศูนย์");
    }

    if (!customerData?.ref || !customerData?.newContno) {
      return message.warning("error ค่าอ้างอิงหาย");
    }
    // คำนวณยอดรวมจาก Object otherPayments
    const totalToPay = Object.values(otherPayments).reduce((sum, val) => {
      // กรองเอาเฉพาะที่เป็นตัวเลข และป้องกันค่า undefined/null
      const num = parseFloat(val) || 0;
      return sum + num;
    }, 0);

    if (totalToPay <= 0) {
      return message.warning(
        "กรุณาระบุยอดเงินในรายการที่ต้องการชำระอย่างน้อย 1 รายการ",
      );
    }

    confirm({
      title: "ยืนยันการบันทึกรายการรับลูกหนี้อื่นๆ ?",
      icon: <SaveOutlined style={{ color: "#1d39c4" }} />,
      okText: "ยืนยันบันทึก",
      cancelText: "ยกเลิก",
      okButtonProps: { style: { background: "#1d39c4" } },
      onOk() {
        // เรียกฟังก์ชันยิงหลังบ้าน
        // console.log("otherPayments : ", otherPayments)
        saveToBackendAR(totalToPay);
      },
      onCancel() {
        console.log("User cancelled");
      },
    });
  };

  const saveToBackendAR = async (totalToPay) => {
    setLoading(true);
    try {
      message.loading({
        content: "กำลังบันทึกข้อมูลลูกหนี้อื่นๆ...",
        key: "save_process_ar",
      });

      // ปั้นโครงสร้างข้อมูล "arothr" ตามที่หลังบ้านต้องการ
      // กรองเอาเฉพาะรายการที่มีการกรอกเงิน (PAY > 0)
      const arothrPayload = dataAll?.arothr
        .filter((item) => (otherPayments[item.ARCONT] || 0) > 0) // กรองเอาเฉพาะตัวที่มียอดจ่าย
        .map((item) => ({
          ...item, // คัดลอกข้อมูลเดิมทั้งหมด (ARCONT, TSALE, CONTNO, ฯลฯ)
          PAY: otherPayments[item.ARCONT], // อัปเดตยอดเงินที่กรอกลงในฟิลด์ PAY
        }));

      const finalPayload = {
        PAYCODE: paymentType,
        money: totalToPay, // ยอดรวม
        idJudge: customerData?.idJudge,
        idJudgeDef: customerData?.idJudgeDef,
        ref: customerData?.ref,
        newContno: customerData?.newContno,
        arothr: arothrPayload, // ส่งไปเป็น Array ของ Object ตามที่คุณระบุ
      };

      const response = await axios.post(
        `${BASE_URL_BEN}/auth/insert-pay-arothr`,
        finalPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tk}`,
          },
        },
      );
      console.log("response AR", response.data);
      if (response.status === 200) {
        message.success({
          content: (
            <span style={{ fontSize: "22px", fontWeight: "bold" }}>
              บันทึกรายการสำเร็จ!
            </span>
          ),
          key: "save_process_ar",
          style: { padding: "12px 25px", fontSize: "22px", marginTop: "10vh" },
          duration: 1, // แสดงค้างไว้นาน 3 วินาที
        });
        // เพิ่ม Logic หลังบันทึกสำเร็จ เช่น ล้างค่า หรือเปิดใบเสร็จ
        if (response.data.bill) {
          setBill(response.data.bill);
          setLockInput(true);
        }
      }
    } catch (error) {
      console.log("error AR", error);
      message.error({
        content: "เกิดข้อผิดพลาดในการบันทึก",
        key: "save_process_ar",
      });
    } finally {
      setLoading(false);
    }
  };

  const printpay = async () => {
    if (!bill) return message.warning("ไม่พบใบเสร็จ");
    // 1. ดัก Error ก่อนเลย (Guard Clause)
    if (![1, 2].includes(paymentMode)) {
      return message.warning("ไม่ตรงกับเงื่อนไข paymentMode");
    }
    console.log("dataRec : ", dataRec);
    if (dataRec) {
      setLoading(true);
      await PaymentLawyerPdfJs(dataRec);
      setLoading(false);
      return;
    }

    let payForCode = "777";
    if (dataAll?.flagLoanNew === 2 && dataAll?.flagDue === 0) {
      payForCode = customerData?.costOfUselessness > 0 ? "999" : "888";
    } else if (dataAll?.flagLoanNew === 2 && dataAll?.flagDue === 1) {
      payForCode = "778";
    }

    // 3. สร้าง Object แค่ครั้งเดียว
    const finalPayload = {
      TMBILL: bill,
      CONTNO: customerData?.newContno,
      PAYFOR: payForCode,
    };

    setDataRec(null);
    setLoading(true);
    try {
      message.loading({
        content: "กำลังโหลดข้อมูลใบเสร็จ...",
        key: "load_process_print",
      });

      const response = await axios.post(
        `${BASE_URL_BEN}/auth/print-payment-lawyer`,
        finalPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tk}`,
          },
        },
      );
      console.log("response print", response.data);
      if (response.status === 200 && response.data) {
        // 1. เก็บข้อมูลลง State
        setDataRec(response.data);

        // 2. ปิด Loading
        message.success({
          content: "โหลดข้อมูลสำเร็จ",
          key: "load_process_print",
        });

        await PaymentLawyerPdfJs(response.data);
      } else {
        message.warning({
          content: "ไม่พบข้อมูลใบเสร็จ",
          key: "load_process_print",
        });
      }
    } catch (error) {
      console.log("error AR", error);
      message.error({
        content: "เกิดข้อผิดพลาดในการโหลดใบเสร็จ",
        key: "load_process_print",
      });
    } finally {
      setLoading(false);
    }
  };

  const printpayAR = async () => {
    if (!bill) return message.warning("AR ไม่พบใบเสร็จ");
    // 1. ดัก Error ก่อนเลย (Guard Clause)
    if (paymentMode !== 3) {
      return message.warning("AR ไม่ตรงกับเงื่อนไข paymentMode");
    }
    console.log("dataRec AR : ", dataRec);
    if (dataRec) {
      setLoading(true);
      await PaymentArLawyerPdfjs(dataRec);
      setLoading(false);
      return;
    }

    const finalPayload = {
      TMBILL: bill,
      CONTNO: customerData?.newContno,
    };

    setDataRec(null);
    setLoading(true);
    try {
      message.loading({
        content: "กำลังโหลดข้อมูลใบเสร็จ...",
        key: "load_process_ar_print",
      });

      const response = await axios.post(
        `${BASE_URL_BEN}/auth/print-payment-lawyer-ar`,
        finalPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tk}`,
          },
        },
      );
      console.log("response print", response.data);
      if (response.status === 200 && response.data) {
        // 1. เก็บข้อมูลลง State
        setDataRec(response.data);

        // 2. ปิด Loading
        message.success({
          content: "โหลดข้อมูลสำเร็จ",
          key: "load_process_ar_print",
        });

        await PaymentArLawyerPdfjs(response.data);
      } else {
        message.warning({
          content: "ไม่พบข้อมูลใบเสร็จ",
          key: "load_process_ar_print",
        });
      }
    } catch (error) {
      console.log("error AR", error);
      message.error({
        content: "เกิดข้อผิดพลาดในการโหลดใบเสร็จ",
        key: "load_process_ar_print",
      });
    } finally {
      setLoading(false);
    }
  };

  // const renderButton = () => {
  //   console.log("dataAll?.arothr?", dataAll?.arothr);
  //   console.log("dataAll", dataAll);

  //   return (
  //     <Space wrap>
  //       {dataAll && (
  //         <Button
  //           type={paymentMode === 1 ? "primary" : "default"}
  //           style={{
  //             backgroundColor: "#efa420",
  //             borderColor: "#ffcb05",
  //           }}
  //           onClick={() => handleModeChange(1)}
  //           disabled={!flagPay}
  //           icon={paymentMode === 1 && <CheckCircleOutlined />}
  //         >
  //           1. รับปกติ
  //         </Button>
  //       )}
  //       {dataAll?.arothr?.length > 0 && (
  //         <Button
  //           type={paymentMode === 3 ? "primary" : "default"}
  //           style={{
  //             backgroundColor: "#efa420",
  //             borderColor: "#ffcb05",
  //           }}
  //           onClick={() => handleModeChange(3)}
  //           disabled={!flagPay}
  //           icon={paymentMode === 3 && <CheckCircleOutlined />}
  //         >
  //           2. รับค่าใช้จ่ายอื่นๆ
  //         </Button>
  //       )}
  //     </Space>

  //   );
  // };

  const renderButton = () => {
    // แสดงปุ่มเฉพาะ พิพากษาปกติ (2) หรือ พิพากษาทำยอม (1)
    if (!dataAll || ![1, 2].includes(dataAll.flagLoanNew)) return null;

    const hasOtherExpenses = dataAll?.arothr?.length > 0;
    // ตารางดิว (loanJudge) ไม่มีการรับค่าใช้จ่ายอื่นๆ จึงซ่อนปุ่มนี้
    const isLoanJudge = dataAll.flagLoanNew === 2 && dataAll.loanJudge;
    const showOtherExpenseButton = hasOtherExpenses && !isLoanJudge;

    // helper function (ไม่ใช่ component) เพื่อไม่ให้ปุ่ม remount ทุกครั้งที่ render
    const renderPaymentButton = (mode, label) => (
      <Button
        type={paymentMode === mode ? "primary" : "default"}
        style={{ backgroundColor: "#efa420", borderColor: "#ffcb05" }}
        onClick={() => handleModeChange(mode)}
        disabled={!flagPay}
        icon={paymentMode === mode ? <CheckCircleOutlined /> : undefined}
      >
        {label}
      </Button>
    );

    return (
      <Space wrap>
        {renderPaymentButton(1, "1. รับปกติ")}
        {showOtherExpenseButton &&
          renderPaymentButton(3, "2. รับค่าใช้จ่ายอื่นๆ")}
      </Space>
    );
  };

  const loadPath = async (loanId) => {
    setLoading(true);

    try {
      const imgRes = await axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/10/${loanId}`, {
        headers: HEADERS_UPIMAGE,
      });

      setRejudgeImages(imgRes.data ?? []);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาด: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  console.log(dataAll);

  const sendNoti = async () => {
    const dataUse = dataAll?.data?.[0];
    const payload = {
      case_no: dataUse?.newContno,
      case_name: dataUse?.SNAM + dataUse?.NAME1 + "  " + dataUse?.NAME2,
      notify_to: [1, 4],
      action_by: "การเงิน",
      message: `การเงินรับยอดรีไฟแนนซ์สำเร็จ กรุณาขอเอกสารใบเสร็จจากการเงินเพื่อดำเนินการขั้นต่อไป`,
    };

    try {
      const res = await axios.post(API_LINE_NOTI, payload, {
        headers: header,
      });

      if (res.status === 200) {
        message.success(`ส่งแจ้งเตือนเบลสำเร็จ`);
        return { success: true, status: res.status };
      } else {
        message.error("ไม่สามารถส่งข้อมูลได้");
        return { success: false, error: "ไม่สามารถส่งข้อมูลได้" };
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMsg =
        error.response?.data?.message || "เกิดข้อผิดพลาดในการอัพเดทข้อมูล";
      message.error(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

  return (
    <>
      <Spin spinning={loading} size="large" tip=" Loading... ">
        <Card
          style={{
            marginBottom: 8,
            borderRadius: 12,
            border: "1px solid #ffcb05",
            background: "#fffdf0",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              flexWrap: "wrap",
            }}
          >
            {/* Label */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                padding: "6px 12px",
                borderRadius: 8,
                background: "#fff3cc",
                border: "1px solid #ffcb05",
                whiteSpace: "nowrap",
              }}
            >
              <span style={{ fontSize: 14, color: "#efa420" }}>🔍</span>
              <span style={{ fontSize: 13, fontWeight: 500, color: "#efa420" }}>
                ค้นหาสัญญา
              </span>
            </div>
            <div>
              <Input.Search
                size="large"
                placeholder="...กรอกเลขสัญญา"
                onSearch={onSearch}
                loading={loading}
                enterButton={
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    style={{
                      backgroundColor: "#efa420",
                      borderColor: "#efa420",
                      color: "#fff",
                    }}
                  />
                }
              />
            </div>
            {renderButton()}
            {loading && (
              <span
                style={{
                  marginLeft: "auto",
                  color: "#efa420",
                  fontSize: 12,
                  whiteSpace: "nowrap",
                }}
              >
                ⏳ กำลังโหลด...
              </span>
            )}
          </div>
          <Text style={{ color: "red" }}>
            หมายเหตุ* ค้นหาเฉพาะสัญญาใหม่เท่านั้น
          </Text>
        </Card>

        {customerData && (
          <Row gutter={[16, 16]}>
            {/* --- ฝั่งซ้าย: ข้อมูลลูกค้า + รายละเอียดหนี้ --- */}
            <Col xs={24} lg={10}>
              <Space
                direction="vertical"
                style={{ width: "100%" }}
                size="middle"
              >
                <Card
                  title={
                    <span>
                      <UserOutlined /> ข้อมูลผู้ชำระ
                    </span>
                  }
                  variant={false}
                >
                  <Form.Item label="เลือกรายการ">
                    <Select
                      disabled={!flagPay}
                      style={{ width: "100%", marginBottom: 16 }}
                      value={customerData?.idJudgeDef}
                      onChange={handleSelectCustomer}
                      options={dataList.map((item) => ({
                        // เช็คเงื่อนไขเพื่อต่อข้อความท้ายชื่อ
                        label: item?.acquitted
                          ? `${item.defendantNumber}. ${item.NAME1} ${item.NAME2} (พ้นความผิดแล้ว)`
                          : `${item.defendantNumber}. ${item.NAME1} ${item.NAME2}`,
                        value: item.idJudgeDef,
                        // ถ้า acquitted เป็น true ให้ตั้ง disabled เป็น true เพื่อล็อคไม่ให้กด
                        disabled: item?.acquitted || lockInput,
                      }))}
                    />
                  </Form.Item>
                  <Row gutter={[32, 8]}>
                    {" "}
                    {/* ปรับ gutter เพื่อเว้นระยะห่างระหว่างคอลัมน์ซ้าย-ขวา */}
                    <Col xs={24} md={12}>
                      <InfoRow
                        label="รหัสลูกค้า"
                        value={customerData.CUSCOD}
                        strong
                        fontSize={14}
                      />
                    </Col>
                    <Col xs={24} md={12}>
                      <InfoRow
                        label="บุคคลประเภท"
                        value={
                          customerData.ref === "001"
                            ? "คนกู้"
                            : customerData.ref === "002"
                              ? "คนค้ำประกัน"
                              : customerData.ref
                        }
                        strong
                        fontSize={14}
                      />
                    </Col>
                    {!dataAll.loanNew && !dataAll.loanJudge ? (
                      <>
                        <Col xs={24} md={12}>
                          <InfoRow
                            label="เงินต้นที่ต้องชำระ"
                            value={Number(
                              customerData?.BALANCE || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            strong
                            fontSize={14}
                          />
                        </Col>
                        <Col xs={24} md={12}>
                          <InfoRow
                            label="ค่าประโยชน์ที่ต้องชำระ"
                            value={Number(
                              customerData?.costOfUselessness || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            strong
                            fontSize={14}
                          />
                        </Col>
                      </>
                    ) : null}
                  </Row>
                </Card>

                <Card
                  title={
                    <span>
                      <WalletOutlined /> รายละเอียดทางการเงินของสัญญา{" "}
                      {customerData?.newContno}{" "}
                      {dataAll?.flagLoanNew === 1
                        ? "( ทำยอม )"
                        : dataAll?.loanJudge
                          ? "( พิพากษาปกติ ตารางดิว )"
                          : dataAll?.flagLoanNew === 2
                            ? "( พิพากษาปกติ )"
                            : ""}
                    </span>
                  }
                  variant={false}
                  size="small"
                >
                  <Row gutter={[32, 8]}>
                    {/* --- ส่วนยอดปิดบัญชี (จัดกลาง) --- */}
                    {dataAll?.loanJudge ? (
                      <Col span={24}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "baseline",
                            gap: "10px",
                            paddingTop: "8px",
                          }}
                        >
                          <Typography.Text
                            type="secondary"
                            style={{ fontSize: 18 }}
                          >
                            ยอดปิดบัญชี:
                          </Typography.Text>
                          <Typography.Text
                            strong
                            style={{ color: "#52c41a", fontSize: 18 }}
                          >
                            {Number(
                              dataAll?.loanJudge?.closingbalance || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                          </Typography.Text>
                        </div>
                        <Divider style={{ margin: "12px 0 16px 0" }} />
                      </Col>
                    ) : !dataAll.loanNew ? (
                      <Col span={24}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center", // จัดให้อยู่กึ่งกลางแนวนอน
                            alignItems: "baseline", // จัดให้ฐานตัวหนังสือเท่ากัน (ดูโปรฯ กว่า center ปกติ)
                            gap: "10px", // เว้นระยะห่างระหว่างชื่อกับตัวเลข
                            paddingTop: "8px",
                          }}
                        >
                          <Typography.Text
                            type="secondary"
                            style={{ fontSize: 18 }}
                          >
                            ยอดปิดบัญชี:
                          </Typography.Text>
                          <Typography.Text
                            strong
                            style={{ color: "#52c41a", fontSize: 18 }}
                          >
                            {Number(
                              customerData?.closingbalance || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                          </Typography.Text>
                        </div>
                        <Divider style={{ margin: "12px 0 16px 0" }} />
                      </Col>
                    ) : (
                      <Col span={24}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center", // จัดให้อยู่กึ่งกลางแนวนอน
                            alignItems: "baseline", // จัดให้ฐานตัวหนังสือเท่ากัน (ดูโปรฯ กว่า center ปกติ)
                            gap: "10px", // เว้นระยะห่างระหว่างชื่อกับตัวเลข
                            paddingTop: "8px",
                          }}
                        >
                          <Typography.Text
                            type="secondary"
                            style={{ fontSize: 18 }}
                          >
                            ยอดปิดบัญชี:
                          </Typography.Text>
                          <Typography.Text
                            strong
                            style={{ color: "#52c41a", fontSize: 18 }}
                          >
                            {Number(
                              dataAll?.loanNew?.LOAN_NEW_CCB || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                          </Typography.Text>
                        </div>
                        <Divider style={{ margin: "12px 0 16px 0" }} />
                      </Col>
                    )}

                    {/* --- คอลัมน์ที่ 1 (ฝั่งซ้าย) --- */}
                    <Col xs={24} md={12}>
                      {dataAll?.loanJudge ? (
                        <>
                          <InfoRow
                            label="เงินต้นคงเหลือ"
                            value={Number(
                              dataAll?.loanJudge?.principalRemain || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            strong
                            fontSize={14}
                          />
                          <InfoRow
                            label="ดอกเบี้ย"
                            value={(
                              Number(
                                dataAll?.loanJudge?.calInterestTable || 0,
                              ) +
                              Number(dataAll?.loanJudge?.calInterestDaily || 0)
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            strong
                            fontSize={14}
                          />

                          <InfoRow
                            label="ดอกเบี้ยคงค้าง"
                            value={Number(
                              dataAll?.loanJudge?.RES_BEEYPUP_JUDGE || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            color="#cf1322"
                            fontSize={14}
                          />
                        </>
                      ) : !dataAll.loanNew ? (
                        <>
                          <InfoRow
                            label="เงินต้นคงเหลือ"
                            value={(Number(customerData?.BALANCE || 0) > 0
                              ? Number(customerData?.TONBALANCE)
                              : 0
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            strong
                            fontSize={14}
                          />
                          <InfoRow
                            label="รวม"
                            value={(Number(customerData?.BALANCE || 0) > 0
                              ? Number(customerData?.TONBALANCE || 0) +
                                Number(customerData?.calInterest || 0)
                              : 0
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            color="#52c41a"
                            fontSize={14}
                          />
                          <InfoRow
                            label="ค่าขาดประโยชน์"
                            value={(Number(
                              customerData?.costOfUselessness || 0,
                            ) > 0
                              ? Number(customerData?.LACK_BALANCE)
                              : 0
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            strong
                            fontSize={14}
                          />
                          <InfoRow
                            label="รวม"
                            value={(Number(
                              customerData?.costOfUselessness || 0,
                            ) > 0
                              ? Number(customerData?.LACK_BALANCE || 0) +
                                Number(customerData?.calInterestCost || 0)
                              : 0
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            color="#52c41a"
                            fontSize={14}
                          />
                          <InfoRow
                            label="ลูกหนี้อื่นๆ"
                            value={Number(customerData?.arKong).toLocaleString(
                              undefined,
                              { minimumFractionDigits: 2 },
                            )}
                            color="#cf1322"
                            fontSize={14}
                          />
                        </>
                      ) : (
                        <>
                          <InfoRow
                            label="เงินต้นคงเหลือ"
                            value={Number(
                              dataAll?.loanNew?.LOAN_NEW_TONBALANCE || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            strong
                            fontSize={14}
                          />
                          <InfoRow
                            label="ดอกเบี้ยคงค้าง"
                            value={Number(
                              dataAll?.loanNew?.RES_BEEYPUP || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            strong
                            fontSize={14}
                          />
                          <InfoRow
                            label="ลูกหนี้อื่นๆ"
                            value={Number(
                              dataAll?.loanNew?.LOAN_NEW_AR || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            color="#cf1322"
                            fontSize={14}
                          />
                        </>
                      )}
                    </Col>

                    {/* --- คอลัมน์ที่ 2 (ฝั่งขวา) --- */}
                    <Col xs={24} md={12}>
                      {dataAll?.loanJudge ? null : !dataAll.loanNew ? (
                        <>
                          {/* 1. คู่กับ เงินต้นคงเหลือ */}
                          <InfoRow
                            label="ค้างดอกเบี้ย (ต้น)"
                            value={(Number(customerData?.BALANCE || 0) > 0
                              ? Number(customerData?.calInterest || 0)
                              : 0
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            color="#cf1322"
                            fontSize={14}
                            strong // ใส่ strong เพื่อให้ความสูงเท่ากับฝั่งซ้ายที่มี strong (ถ้าฝั่งซ้ายมี)
                          />

                          {/* 2. คู่กับ รวม (เงินต้น) - ใช้เป็นช่องว่างแต่จองพื้นที่ */}
                          <InfoRow
                            label="&nbsp;" // ใช้ &nbsp; (Space แบบไม่ยุบ) เพื่อดันความสูง Label
                            value="&nbsp;" // ใช้ &nbsp; เพื่อดันความสูง Value
                            strong // ใส่ strong ให้เหมือนฝั่งซ้าย เพื่อให้ Line-height เท่ากันเป๊ะ
                            fontSize={14}
                          />

                          {/* 3. คู่กับ ค่าขาดประโยชน์ */}
                          <InfoRow
                            label="ค้างดอกเบี้ย (ขาดประโยชน์)"
                            value={(Number(
                              customerData?.costOfUselessness || 0,
                            ) > 0
                              ? Number(customerData?.calInterestCost || 0)
                              : 0
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            color="#cf1322"
                            fontSize={14}
                            strong
                          />

                          {/* 4. คู่กับ รวม (ขาดประโยชน์) - ใช้เป็นช่องว่างแต่จองพื้นที่ */}
                          <InfoRow
                            label="&nbsp;"
                            value="&nbsp;"
                            strong // ใส่ strong ให้เหมือนฝั่งซ้าย
                            fontSize={14}
                          />

                          {/* 5. คู่กับ ลูกหนี้อื่นๆ (เพิ่มบรรทัดนี้เข้ามาให้ครบ 5 แถว) */}
                          <InfoRow
                            label="&nbsp;"
                            value="&nbsp;"
                            fontSize={14}
                          />
                        </>
                      ) : null}
                    </Col>
                  </Row>
                </Card>
              </Space>
            </Col>

            {paymentMode === 3 ? (
              /* --- การ์ดจ่ายค่าใช้จ่ายอื่นๆ (Mode 3) --- */
              <Col xs={24} lg={14}>
                <Card
                  title={
                    <span>
                      <FileTextOutlined /> รายการค่าใช้จ่ายอื่นๆ
                    </span>
                  }
                  variant={false}
                  style={{ height: "100%" }}
                  // ใส่ปุ่มตรงนี้ครับ
                  extra={
                    <Button
                      disabled={!bill}
                      style={{ height: "100%" }}
                      type="primary"
                      onClick={() => printpayAR()}
                      icon={<PrinterOutlined />}
                    >
                      พิมพ์ใบเสร็จรับเงิน
                    </Button>
                  }
                >
                  <div
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      marginBottom: "16px",
                    }}
                  >
                    <Col span={24}>
                      <Text strong>ประเภทการจ่าย</Text>
                      <Select
                        value={paymentType} // ใช้ค่าจาก State
                        size="large"
                        style={{ width: "100%", marginTop: 8 }}
                        onChange={(val) => setPaymentType(val)} // อัปเดต State เมื่อมีการเลือกใหม่
                        disabled={lockInput}
                      >
                        {getPAYCODE?.map((e) => {
                          return (
                            <Select.Option key={e.keyId} value={e.PAYCODE}>
                              {e.PAYCODE} ({e.PAYDESC})
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Col>

                    {dataAll?.arothr?.map((item, index) => {
                      let title = "";
                      let responsible = 0;

                      if (
                        customerData.trackingFee > 0 &&
                        item.PAYFOR === "111"
                      ) {
                        title = "ค่าติดตาม";
                        responsible = customerData.trackingFee;
                      } else if (
                        customerData.attorneyFees > 0 &&
                        item.PAYFOR === "222"
                      ) {
                        title = "ค่าทนาย";
                        responsible = customerData.attorneyFees;
                      } else if (
                        customerData.fee > 0 &&
                        item.PAYFOR === "333"
                      ) {
                        title = "ค่าธรรมเนียม";
                        responsible = customerData.fee;
                      } else if (
                        customerData.judgeNumber === 1 &&
                        item.PAYFOR === "444"
                      ) {
                        title = "ดอกเบี้ยก่อนฟ้อง";
                        responsible = customerData.judgementInterest;
                      } else if (
                        Number(customerData.costOfUselesenessPerMonth) *
                          Number(customerData.costOfUselesenessMonth) >
                          0 &&
                        item.PAYFOR === "555"
                      ) {
                        title = "ค่าขาดประโยชน์รายเดือน";
                        responsible =
                          Number(customerData.costOfUselesenessPerMonth) *
                          Number(customerData.costOfUselesenessMonth);
                      } else if (item.FORTYPE === 2) {
                        // ✅ รายการที่เพิ่มเอง → ใช้ FORDESC เป็น title, PAYAMT เป็น responsible
                        title = item.FORDESC || `รายการ ${item.PAYFOR}`;
                        responsible = Number(item.PAYAMT);
                      }

                      if (!title) return null;

                      const remainAmount =
                        Number(item.PAYAMT) - Number(item.SMPAY);
                      const maxAllowed = Math.min(
                        remainAmount,
                        Number(responsible),
                      );

                      return (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "12px",
                            borderBottom: "1px solid #f0f0f0",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <Text type="secondary">{title}</Text> {"  "}
                            <Text
                              strong
                              style={{ fontSize: "14px", color: "#0C0A09" }}
                            >
                              ยอด:{" "}
                              {Number(item.PAYAMT).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })}
                            </Text>{" "}
                            {"  "}
                            <Text
                              strong
                              style={{ fontSize: "14px", color: "#096dd9" }}
                            >
                              (ยอดที่ต้องรับผิดชอบ:{" "}
                              {Number(responsible).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })}
                              )
                            </Text>
                            <br />
                            <Text
                              strong
                              style={{ fontSize: "14px", color: "#cf1322" }}
                            >
                              ชำระมาแล้ว:{" "}
                              {Number(item.SMPAY).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })}
                            </Text>
                          </div>

                          {remainAmount !== 0 && (
                            <div style={{ width: "200px" }}>
                              <InputNumber
                                style={{ width: "100%" }}
                                placeholder="ระบุยอดจ่าย"
                                min={0}
                                max={maxAllowed}
                                value={otherPayments[item.ARCONT]}
                                disabled={lockInput}
                                onChange={(val) => {
                                  handleOtherPaymentChange(item.ARCONT, val);
                                }}
                                formatter={(v) =>
                                  `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                }
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  <Divider />

                  <div style={{ textAlign: "right", marginBottom: "16px" }}>
                    <Text type="secondary">รวมยอดชำระอื่นๆ ทั้งสิ้น:</Text>
                    <Title level={2} style={{ margin: 0, color: "#1890ff" }}>
                      ฿{" "}
                      {Object.values(otherPayments)
                        .reduce((a, b) => a + b, 0)
                        .toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })}
                    </Title>
                  </div>

                  <Button
                    variant="filled"
                    color="green"
                    size="large"
                    icon={<SaveOutlined />}
                    block
                    onClick={showConfirmAR}
                    disabled={
                      Object.values(otherPayments).every((v) => v <= 0) ||
                      !flagPay
                    }
                  >
                    บันทึกรับชำระค่าใช้จ่ายอื่นๆ
                  </Button>
                </Card>
              </Col>
            ) : (
              <>
                {/* --- ฝั่งขวา: ส่วนการรับเงินและการคำนวณ --- */}
                <Col xs={24} lg={14}>
                  <Card
                    title={`บันทึกจำนวนเงินและการคำนวณ ${getModeName(paymentMode)}`}
                    variant={false}
                    style={{ height: "100%" }}
                    // ใส่ปุ่มตรงนี้ครับ
                    extra={
                      <Button
                        disabled={!bill}
                        style={{ height: "100%" }}
                        type="primary"
                        onClick={() => printpay()}
                        icon={<PrinterOutlined />}
                      >
                        พิมพ์ใบเสร็จรับเงิน
                      </Button>
                    }
                  >
                    <Row gutter={[16, 16]}>
                      <Col span={24}>
                        {dataAll?.rejudgeRequest && (
                          <>
                            <Text strong>ข้อมูลการขอรีสัญญา</Text>
                            <InfoRow
                              label="ยอดอนุมัติ รีไฟแนนซ์"
                              value={Number(
                                dataAll?.rejudgeRequest?.receiveAmount || 0,
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })}
                              strong
                              fontSize={14}
                            />
                            <InfoRow
                              label="วันที่อนุมัติ"
                              value={
                                formatThaiDate(
                                  dataAll?.rejudgeRequest?.createdAt,
                                ) || "-"
                              }
                              strong
                              fontSize={14}
                            />
                            <InfoRow
                              label="ส่วนลด"
                              value={Number(
                                dataAll?.rejudgeRequest?.discountAtCreate || 0,
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })}
                              strong
                              fontSize={14}
                            />
                            <InfoRow
                              label="หมายเหตุ"
                              value={dataAll?.rejudgeRequest?.note || 0}
                              strong
                              fontSize={14}
                            />
                            {rejudgeImages.filter((img) => img.imageType === 17)
                              .length > 0 && (
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 8,
                                  marginTop: 8,
                                }}
                              >
                                {rejudgeImages
                                  .filter((img) => img.imageType === 17)
                                  .map((img, index) => {
                                    const src = `${GET_LOAD_IMAGE_NEW_BY}/${img.path}?token=${tk}`;

                                    if (getFileType(img.path) === "pdf") {
                                      return (
                                        <div
                                          key={img.path || index}
                                          onClick={() => {
                                            setPdfPreviewUrl(src);
                                            setPdfPreviewOpen(true);
                                          }}
                                          style={{
                                            width: 80,
                                            height: 80,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: "#fff1f0",
                                            borderRadius: 8,
                                            border: "1px dashed #ff4d4f",
                                            gap: 4,
                                            cursor: "pointer",
                                            transition: "opacity 0.2s",
                                          }}
                                          onMouseEnter={(e) =>
                                            (e.currentTarget.style.opacity =
                                              "0.7")
                                          }
                                          onMouseLeave={(e) =>
                                            (e.currentTarget.style.opacity =
                                              "1")
                                          }
                                        >
                                          <FilePdfOutlined
                                            style={{
                                              fontSize: 28,
                                              color: "#ff4d4f",
                                            }}
                                          />
                                          <span
                                            style={{
                                              fontSize: 12,
                                              color: "#ff4d4f",
                                              fontWeight: 500,
                                            }}
                                          >
                                            <EyeOutlined
                                              style={{ marginRight: 4 }}
                                            />
                                            ดู PDF
                                          </span>
                                        </div>
                                      );
                                    }

                                    return (
                                      <img
                                        key={img.path || index}
                                        src={src}
                                        alt={`เอกสารรีไฟแนนซ์ ${index + 1}`}
                                        style={{
                                          width: 80,
                                          height: 80,
                                          objectFit: "cover",
                                          borderRadius: 8,
                                          border: "1px solid #d9d9d9",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setPreviewUrl(src);
                                          setPreviewOpen(true);
                                        }}
                                      />
                                    );
                                  })}
                              </div>
                            )}
                          </>
                        )}
                        <Text strong>ประเภทการจ่าย</Text>
                        <Select
                          value={paymentType} // ใช้ค่าจาก State
                          size="large"
                          style={{ width: "100%", marginTop: 8 }}
                          onChange={(val) => setPaymentType(val)} // อัปเดต State เมื่อมีการเลือกใหม่
                          disabled={lockInput}
                        >
                          {getPAYCODE?.map((e) => {
                            return (
                              <Select.Option key={e.keyId} value={e.PAYCODE}>
                                {e.PAYCODE} ({e.PAYDESC})
                              </Select.Option>
                            );
                          })}
                        </Select>
                      </Col>
                      <Col span={12}>
                        <Text strong>กรอกจำนวนเงินรับจริง</Text>
                        <InputNumber
                          min={0}
                          style={{ width: "100%", marginTop: 8 }}
                          size="large"
                          value={money}
                          // 2. ปรับ onChange เผื่อกรณีพิมพ์เลขติดลบแล้วอยากให้ State เป็น 0 ทันที (กันไว้ 2 ชั้น)
                          onChange={(val) => handleMoney(val < 0 ? 0 : val)}
                          formatter={(v) =>
                            `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                          // 3. (สำคัญมาก) ต้องมี parser เพื่อลบลูกน้ำออก ไม่งั้นค่า value จะเพี้ยนตอนคำนวณ
                          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                          disabled={!paymentMode || lockInput}
                        />
                      </Col>
                      <Col span={12}>
                        <Text strong>
                          กรอกส่วนลด{" "}
                          {dataAll?.flagLoanNew === 1
                            ? "( ดอกเบี้ยคงค้าง )"
                            : dataAll?.flagLoanNew === 2
                              ? "( ดอกเบี้ย )"
                              : ""}
                        </Text>
                        <InputNumber
                          min={0}
                          style={{ width: "100%", marginTop: 8 }}
                          size="large"
                          status="warning"
                          value={sale}
                          // 2. ปรับ onChange เผื่อกรณีพิมพ์เลขติดลบแล้วอยากให้ State เป็น 0 ทันที (กันไว้ 2 ชั้น)
                          onChange={(val) => handleSale(val < 0 ? 0 : val)}
                          formatter={(v) =>
                            `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                          // 3. (สำคัญมาก) ต้องมี parser เพื่อลบลูกน้ำออก ไม่งั้นค่า value จะเพี้ยนตอนคำนวณ
                          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                          disabled={!paymentMode || lockInput}
                        />
                      </Col>
                      <Col span={24}>
                        <Button
                          variant="filled"
                          color="blue"
                          block
                          size="large"
                          icon={<CalculatorOutlined />}
                          onClick={() => {
                            if (sale > dataAll?.loanNew?.RES_BEEYPUP) {
                              Modal.confirm({
                                title: "คำเตือน !!",
                                content:
                                  "ส่วนลดมากกว่าดอกเบี้ยกรุณาตรวจสอบให้แน่ใจ !",
                                okText: "ยืนยัน",
                                cancelText: "ยกเลิก",
                                onOk: handleCalculate,
                                onCancel: () => message.info("ยกเลิกการคำนวน"),
                              });
                            } else {
                              handleCalculate();
                            }
                          }}
                          disabled={!canCalculate || lockInput}
                        >
                          กดคำนวณ
                        </Button>
                      </Col>
                    </Row>

                    <Divider dashed />

                    {dataCal && (
                      <>
                        <Text strong>ผลลัพธ์</Text>
                        <Row gutter={[32, 8]}>
                          {" "}
                          {/* ปรับ gutter เพื่อเว้นระยะห่างระหว่างคอลัมน์ซ้าย-ขวา */}
                          <Col xs={24} md={8}>
                            <InfoRow
                              label="รวม"
                              value={Number(dataCal.PAYAMT || 0).toLocaleString(
                                undefined,
                                { minimumFractionDigits: 2 },
                              )}
                              strong
                              fontSize={16}
                            />
                          </Col>
                          <Col xs={24} md={8}>
                            <InfoRow
                              label="ตัดดอกเบี้ย"
                              value={Number(
                                dataCal.PAYAMT_V || 0,
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })}
                              color="#cf1322"
                              fontSize={16}
                            />
                          </Col>
                          <Col xs={24} md={8}>
                            <InfoRow
                              label="ตัดเงินต้น"
                              value={Number(
                                dataCal.PAYAMT_N || 0,
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })}
                              color="#cf1322"
                              fontSize={16}
                            />
                          </Col>
                        </Row>

                        <Divider dashed />
                      </>
                    )}

                    <div style={{ marginTop: 24 }}>
                      <Button
                        variant="filled"
                        color="green"
                        size="large"
                        icon={<SaveOutlined />}
                        block
                        style={{ height: "60px", fontSize: "20px" }}
                        disabled={!dataCal || !flagPay}
                        onClick={showConfirm} // เมื่อกดให้เปิด Confirm ก่อน
                      >
                        บันทึกทำรายการรับเข้า
                      </Button>
                    </div>
                  </Card>
                </Col>
              </>
            )}
          </Row>
        )}
      </Spin>

      <PdfPreviewModal
        open={pdfPreviewOpen}
        url={pdfPreviewUrl}
        onClose={() => {
          setPdfPreviewOpen(false);
          setPdfPreviewUrl("");
        }}
      />

      <Modal
        open={previewOpen}
        onCancel={() => {
          setPreviewOpen(false);
          setPreviewUrl("");
        }}
        footer={null}
        title="ข้อมูลรูปภาพ"
      >
        <img src={previewUrl} alt="preview" style={{ width: "100%" }} />
      </Modal>
    </>
  );
};

const MainReceivePayment = MotionHoc(Main);
export default MainReceivePayment;
